<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<br><br>
<div class="login-box center">
    <div class="login-logo">
        <img class="logoimg" src="assets/img/logo.webp">
    </div>
    <!-- /.login-logo -->
    <div class="card">
      <div class="card-body login-card-body">
        <p class="login-box-msg">Admin Login</p>
  
        <form action="javascript:void(0);">
          <div class="input-group mb-3">
            <input type="email" name="username" class="form-control" placeholder="Email" [(ngModel)]="user.username">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-envelope"></span>
              </div>
            </div>
          </div>
          <div class="input-group mb-3">
            <input [type]="password" name="password"  class="form-control" placeholder="Password" [(ngModel)]="user.password">
            <div class="input-group-append">
              <div class="input-group-text">
                <!-- <span class="fas fa-lock"></span> -->
                <span class="" (click)="onClick()">
                  <span class="fa fa-eye" aria-hidden="true" *ngIf="!show"></span>
                    <span class="fa fa-eye-slash" aria-hidden="true" *ngIf="show"></span>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
          
            <!-- /.col -->
            <div class="col-12">
              <button type="submit" class="btn btn-primary btn-block" (click)="login()" >Sign In</button>
            </div>
            <!-- /.col -->
          </div>
        </form>
        <!-- /.social-auth-links -->
        <p class="mb-1">
          <a [routerLink]="['/forgot-pass']">I forgot my password</a>
        </p>
      </div>
      <!-- /.login-card-body -->
